import React from "react";
import LegacyButton from "../../components/Atomos/Buttons/LegacyButton";

interface SendEmailConfirmationModalProps {
  isOpen: boolean;
  emailNumber: string | number | undefined;
  templateName: string;
  isScheduled: boolean;
  scheduledDate?: string;
  scheduledTime?: string;
  isSubmitting?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export default function SendEmailConfirmationModal ({
  isOpen,
  emailNumber,
  templateName,
  isScheduled,
  scheduledDate,
  scheduledTime,
  isSubmitting = false,
  onCancel,
  onConfirm,
}: SendEmailConfirmationModalProps): React.ReactElement | null {
  if (!isOpen) {
    return null;
  }

  const title = isScheduled ? "Confirm Email Schedule" : "Confirm Email Send";
  const confirmButtonText = isSubmitting
    ? isScheduled
      ? "SCHEDULING..."
      : "SENDING..."
    : isScheduled
      ? "SCHEDULE"
      : "SEND";

  return (
    <div className="fixed inset-0 z-[1000] overflow-y-auto">
      <div
        className="fixed inset-0 bg-black bg-opacity-80"
        onClick={isSubmitting ? undefined : onCancel}
      />

      <div className="flex min-h-full items-center justify-center p-4">
        <div
          className="relative bg-white rounded-lg shadow-xl max-w-md w-full p-6"
          onClick={(e) => e.stopPropagation()}
        >
          <h2 className="text-xl font-decimal font-medium text-Default mb-4">
            {title}
          </h2>

          <p className="text-gray-font mb-6">
            {isScheduled ? (
              <>
                Are you sure you want to schedule this email [
                <span className="font-semibold">{emailNumber}</span>,{" "}
                <span className="font-semibold">{templateName}</span>] to be sent at{" "}
                <span className="font-semibold">{scheduledDate}</span>,{" "}
                <span className="font-semibold">{scheduledTime}</span>?
              </>
            ) : (
              <>
                Are you sure you want to send this email [
                <span className="font-semibold">{emailNumber}</span>,{" "}
                <span className="font-semibold">{templateName}</span>]?
              </>
            )}
          </p>

          <div className="flex justify-end gap-4">
            <LegacyButton
              text="CANCEL"
              style="outlined"
              color="accent"
              content="text"
              size="small"
              onClick={onCancel}
              disabled={isSubmitting}
            />
            <LegacyButton
              text={confirmButtonText}
              style="filled"
              color="accent"
              content="text"
              size="small"
              onClick={onConfirm}
              disabled={isSubmitting}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
